//query params indicating organizationId / accountId, same on every page
export const ANY_PAGE_AUTH_QUERY_PARAMS = {
  organizationId: "organizationId",
  accountId: "accountId",
};
